import React from 'react';
import { FaClock, FaInfoCircle } from 'react-icons/fa';
import './styles.css';

export type MailerSendingBannerProps = {
  /** Nome do relatório/tipo, ex.: "Garantia Financeira", "Relatórios" */
  reportLabel: string;
  /** Mês por extenso, ex.: "Abril" (será exibido em minúsculas) */
  monthName: string;
  year: string | number;
};

function buildTitle({ reportLabel, monthName, year }: MailerSendingBannerProps): string {
  const r = reportLabel.trim().toLowerCase();
  const m = monthName.trim().toLowerCase();
  const y = String(year).trim();
  return `Processando disparo de emails ${r} ref. a ${m} de ${y}`;
}

/**
 * Dois alertas empilhados: título (relógio) e detalhe (ícone "i" cinza).
 */
const MailerSendingBanner: React.FC<MailerSendingBannerProps> = (props) => {
  const title = buildTitle(props);

  return (
    <div className="mailerSendingBanner" role="status" aria-live="polite">
      <div className="mailerSendingBanner__card">
        <div className="mailerSendingBanner__row">
          <FaClock className="mailerSendingBanner__icon" aria-hidden />
          <strong className="mailerSendingBanner__title">{title}</strong>
        </div>
      </div>
      <div className="mailerSendingBanner__card mailerSendingBanner__card--gray">
        <div className="mailerSendingBanner__row">
          <FaInfoCircle
            className="mailerSendingBanner__icon mailerSendingBanner__icon--gray"
            aria-hidden
          />
          <span className="mailerSendingBanner__text">
            <span className="mailerSendingBanner__sentence">
              Os e-mails estão sendo enviados unidade por unidade. Este processo pode levar um tempo.
            </span>
            <span className="mailerSendingBanner__sentence">
              Acompanhe, na tela de controle de envio de e-mails, o andamento pelo status.
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default MailerSendingBanner;
